import {ADD_TO_CART, RECEIVE_PRODUCTS, REMOVE_FROM_CART , REMOVE_PRODUCT_FROM_CART} from "../contents/actionTypes";


const products = (state = {} , action) => {

    switch (action.type)
    {
        case RECEIVE_PRODUCTS:
            return {
                ...action.products.reduce((obj , product) => {
                    obj[product.ID] = {...product , count : !isNaN(product.count) || product.count !== undefined ? product.count : 0}
                    return obj
                } , {})
            }

        case REMOVE_FROM_CART:
        {
            let { productId } = action
            let product = state[productId]
            let count = product.count - 1
            if (count < 0)
                count = 0
            return {
                ...state ,
                [productId] : {
                    ...product ,
                    count :count
                }
            }
        }

        case REMOVE_PRODUCT_FROM_CART:
        {
            let { productId } = action
            let product = state[productId]
            let count = 0
            if (count < 0)
                count = 0
            return {
                ...state ,
                [productId] : {
                    ...product ,
                    count :count
                }
            }
        }

        case ADD_TO_CART:
        {
            let { productId } = action
            let product = state[productId]
            if (product.active === true)
                return {
                    ...state ,
                    [productId] : {
                        ...product ,
                        count : product.count + 1
                    }
                }

            return state
        }

        default:
            return state
    }
}

export default products;